<template>
  <div class="apply-info">
    <div class="header">
      <ds-header title="活动报名信息" style="width: 100%"></ds-header>
      <a-button type="primary" @click="() => $router.go(-1)">返回</a-button>
    </div>

    <a-form layout="inline" class="search-form">
      <a-form-item label="活动报名手机号：">
        <a-input
          v-model.trim="searchForm.mobile"
          placeholder="请输入手机号查询"
          style="width: 220px"
        />
      </a-form-item>
      <span>
        <a-button
          type="primary"
          @click="search"
          style="margin-top: 3px"
          icon="search"
        >
          查询
        </a-button>
        <a-button
          style="margin-left: 15px"
          @click="resetSearchForm"
          icon="redo"
        >
          重置
        </a-button>
      </span>
    </a-form>

    <a-table
      :rowKey="(record, index) => index"
      :columns="table.columns"
      :data-source="table.tableData"
      :pagination="table.pagination.total ? table.pagination : false"
      @change="pageChange"
      bordered
    >
      <span slot="action" slot-scope="text, record" class="action">
        <a-button v-if="record.cancelRegistrationButtonFlag" type="link" @click="handleCancelApply(record)" class="btn">
          取消报名
        </a-button>
      </span>
    </a-table>
  </div>
</template>

<script>
import * as api from '../../../api/enterpriseServiceActivitiesManagement';
import {
  ActivityStatusTextEnum,
  IsChargeEnum,
} from '../../cycleActivities/cycleList/help';

export default {
  name: 'EnterpriseServiceApplyInfo',
  data() {
    return {
      activityId: this.$route.query.id || '',
      searchForm: {
        // 活动报名手机号
        mobile: '',
      },
      table: {
        columns: [
          {
            title: '活动标题',
            dataIndex: 'activityTitle',
            key: 'activityTitle',
            width: 200,
          },
          {
            title: '活动时间',
            dataIndex: 'activityTime',
            key: 'activityTime',
            width: 260,
          },
          {
            title: '活动状态',
            dataIndex: 'activityStatus',
            key: 'activityStatus',
            width: 150,
            customRender(text) {
              return ActivityStatusTextEnum[text] || '-';
            },
          },
          {
            title: '适用项目',
            dataIndex: 'applyProject',
            key: 'applyProject',
            width: 200,
          },
          {
            title: '费用类型',
            dataIndex: 'feeType',
            key: 'feeType',
            width: 150,
            customRender(text) {
              if (text === IsChargeEnum.NO) {
                return '免费';
              }
              if (text === IsChargeEnum.YES) {
                return '现金支付';
              }
              return '-';
            },
          },
          {
            title: '金额（元）',
            dataIndex: 'cash',
            key: 'cash',
            width: 150,
          },
          {
            title: '收款商户',
            dataIndex: 'merchantName',
            key: 'merchantName',
            width: 200,
          },
          {
            title: '活动报名手机号',
            dataIndex: 'connectPhone',
            key: 'connectPhone',
            width: 200,
          },
          {
            title: '活动报名姓名',
            dataIndex: 'connectName',
            key: 'connectName',
            width: 150,
          },
          {
            title: '报名时间',
            dataIndex: 'registrationTime',
            key: 'registrationTime',
            width: 220,
          },
          {
            title: '报名状态',
            dataIndex: 'registrationStatus',
            key: 'registrationStatus',
            width: 150
          },
          {
            title: '核销状态',
            dataIndex: 'verifyStatus',
            key: 'verifyStatus',
            width: 150,
            customRender(text) {
              if (text === 1) {
                return '已核销';
              }
              if (text === 0) {
                return '未核销';
              }
              return '-';
            },
          },
          {
            title: '操作',
            key: 'action',
            width: 120,
            className: 'action-ql-list',
            scopedSlots: { customRender: 'action' },
          },
        ],
        tableData: [],
        pagination: {
          pageSizeOptions: ['10', '20', '30', '50', '100'],
          showSizeChanger: true,
          current: 1,
          pageSize: 10,
          total: 0,
          showQuickJumper: true,
          showTotal: (total) => {
            return `共 ${total} 条`;
          },
        },
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 查询
    search() {
      this.table.pagination.current = 1;
      this.table.pagination.pageSize = 10;
      this.getList();
    },
    // 重置
    resetSearchForm() {
      this.searchForm.mobile = '';
      this.table.pagination.current = 1;
      this.table.pagination.pageSize = 10;
      this.getList();
    },
    getList() {
      if (!this.activityId) {
        this.table.tableData = [];
        this.table.pagination.total = 0;
        return;
      }
      const params = {
        activityId: this.activityId,
        connectPhone: this.searchForm.mobile,
        pageNum: this.table.pagination.current,
        pageSize: this.table.pagination.pageSize,
      };
      api
        .GET_ACTIVITY_REGISTRANT_LIST(params)
        .then((res) => {
          if (res.code === '200') {
            const data = res.data || {};
            this.table.tableData = data.rows || [];
            this.table.pagination.total = data.total || 0;
          } else {
            this.$message.error(res.msg || '查询失败');
          }
        })
        .catch(() => {
          this.$message.error('查询失败');
        });
    },
    // 分页变更
    pageChange(option) {
      this.table.pagination.current = option.current;
      this.table.pagination.pageSize = option.pageSize;
      this.getList();
    },
    handleCancelApply(record) {
      if (!record || !record.activityRegistrantId) {
        this.$message.error('未找到报名信息ID');
        return;
      }
      this.$confirm({
        title: '确定要取消该用户活动报名？',
        onOk: () => {
          const params = {
            activityRegistrantId: record.activityRegistrantId,
            platformFlag: 1
          };
          return api
            .CANCEL_ACTIVITY_REGISTRANT(params)
            .then((res) => {
              if (res.code === '200') {
                this.$message.success(res.msg || '取消成功');
                this.getList();
              } else {
                this.$message.error(res.msg || '取消失败');
              }
            })
            .catch(() => {
              this.$message.error('取消失败');
            });
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.search-form {
  margin-bottom: 10px;
}

.action {
  .btn {
    padding: 0;
    margin: 0;
  }
}
</style>

